import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import { Edit32WHITE, Approved32 } from "../../../../../public/LoginImages/importimages";

import BudgetHeadCreation from "../../BudgetManagement/BudgetHeadCreation/BudgetHeadCreation";


// 08-10 status color
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 

const BudgetHeadList = () => {
  const context = useContext(AdminContext);
  const { GetAllBudgetHeadList, GetBudgetHeadList, BudgetHeadApproval, Usermenu  } = context;
  const [head, setHeadList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  // 16-09
 const [statusFilter, setStatusFilter] = useState("All");  
  // 18-09
 const [menuData, setMenuData] = useState({});
 const [openEdit, setOpenEdit] = useState(false);
 const [editData, setEditData] = useState(null);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);


  const getBudgetHeadList = async () => {
    let data = await GetAllBudgetHeadList();
    console.log("data", data);
    const sortedData = [...data].sort(
      (a, b) => new Date(b.Date) - new Date(a.Date),
    );
    setHeadList(sortedData);
    setFilteredBills(sortedData);
  };

  useEffect(() => {
    getBudgetHeadList();
  }, []);
  let HeadList = [];
  if (head.length > 0) {
    HeadList = head;
  }


// above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = head.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, head]);
  const getPageNumbers = (currentPage, totalPages) => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Ending pages
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };


  
  // 18-09
useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      setMenuData(res.Data);
    };
    getMenu();
  }, []);

  const isChecker =
    menuData?.Department_Name === "State Checker" &&
    menuData?.Role === "State Checker";

  const isMaker =
    menuData?.Department_Name === "State Maker" &&
    menuData?.Role === "State Maker";



    const handleApprove = async (head) => {
  const shouldProceed = window.confirm("Are you sure you want to approve this Budget Head?");
  if (!shouldProceed) return;

  try {
    const response = await BudgetHeadApproval([head.HeadID], "Approved", "");
    if (response?.message) alert(response.message);
    else if (response?.error) alert(response.error);
    getBudgetHeadList(); // refresh list
  } catch (err) {
    console.error("Error approving Budget Head:", err);
    alert("An error occurred while approving.");
  }
};

const thStyle = {
  padding: "10px",
  position: "sticky",
  top: 0,
  zIndex: 2,
};
  return (
     <div
       style={{
         // background: "#ffffff",
         // width: "auto",
         // minHeight: "90vh",
         // transition: "margin-left 0.3s ease",
         // overflowY: "auto",
         // msOverflowStyle: "none",
         // scrollbarWidth: "none",
         // padding: 40,
         // fontFamily: "Inter, sans-serif",
          background: "#ffffff",
     width: "auto",
     // height: "90vh",   
     height:"auto",
     display: "flex",                         // new
     flexDirection: "column",                 // new
     overflowY: openEdit ? "auto" : "hidden", // the edit form still needs to scroll
     boxSizing: "border-box",                 // new
     transition: "margin-left 0.3s ease",
     msOverflowStyle: "none",
     scrollbarWidth: "none",
     padding: 20,                             // was 40, so there is more room for the table
     fontFamily: "Inter, sans-serif",
       }}
     > 
     {/* //29/10 */}
     <div
       style={{
         width: "100%",
         background: "#EEF1F6",
         borderRadius: "12px",
         padding: "18px 15px",
         boxSizing: "border-box",
         boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
         border: "1px solid #E1E6EF",
       }}
     >
       {!openEdit && (
       <div
         // style={{
         //   display: "grid",
         //   justifyContent: "center",
         //   boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
         //   borderRadius: "20px",
         //   backgroundColor: "white",
         //   padding: "20px 25px",
         //   maxHeight: "81vh",
         //   overflow: "auto",
         // }}
         style={{
           width: "100%",
           background: "transparent",
           padding: "0",
           boxSizing: "border-box",
            display: "flex",           // new
   flexDirection: "column",   // new
   flex: "1 1 auto",          // new
   minHeight: 0, 
         }}
       >
         
         <div
           style={{
             display: "flex",
             justifyContent: "space-between",
             alignItems: "center",
             marginBottom: "18px",
             padding: "0",
             width: "100%",
               flexShrink: 0,  
           }}
         >
           <h5
             // style={{
             //   fontWeight: "bold",
             //   color: "black",
             //   display: "flex",
             //   alignItems: "center",
             // }}
             style={{
               margin: 0,
               padding: 0,
               display: "flex",
               alignItems: "center",
               fontSize: "18px",
               fontWeight: "700",
               color: "#111",
               lineHeight: "1.2",
             }}
           >
             <img
     src="/Budger Head Management 32 Size.png"
     alt="img"
     style={{
       width: "25px",
       height: "25px",
       filter: "brightness(0)",
       marginRight:"10px"
     }}
   />
             Budget Head Outward List
           </h5>
  <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
           <div
             // style={{
             //   display: "flex",
             //   alignItems: "center",
             //   backgroundColor: "aliceblue",
             //   border: "1px solid #ccc",
             //   borderRadius: "5px",
             //   padding: "5px 10px",
             //   width: "250px",
             // }}
             style={{
               display: "flex",
               alignItems: "center",
               width: "290px",
               height: "36px",
               backgroundColor: "#ffffff",
               border: "1px solid #d5dce5",
               borderRadius: "8px",
               padding: "0 10px",
               boxSizing: "border-box",
               marginLeft:"10px"
             }}
           >
             <img
               src={"/Search-32.png"}
               alt="Search Icon"
               style={{ width: "18px", height: "18px", marginRight: "8px" }}
             />
             <input
               type="text"
               placeholder="Search Budget Head..."
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
               // style={{
               //   border: "none",
               //   outline: "none",
               //   background: "transparent",
               //   width: "100%",
               //   fontSize: "14px",
               // }}
               style={{
                 width: "100%",
                 height: "100%",
                 border: "none",
                 outline: "none",
                 background: "transparent",
                 fontSize: "12px",
                 color: "#333",
               }}
             />
           </div>
           <select
     value={statusFilter}
     onChange={(e) => setStatusFilter(e.target.value)}
     style={{
         width: "140px",
         height: "36px",
         marginLeft: "10px",
         border: "1px solid #d5dce5",
         borderRadius: "8px",
         padding: "0 10px",
         fontSize: "12px",
         outline: "none",
         background: "#fff",
         cursor: "pointer"
     }}
 >
     <option value="All">All Status</option>
     <option value="Pending">Pending</option>
     <option value="SendBack">SendBack</option>
     <option value="Approved">Approved</option>
     <option value="Rejected">Rejected</option>
 </select></div>
         </div>
 
         <div
           // style={{
           //   width: "100%",
           //   background: "#ffffff",
           //   borderRadius: "10px",
           //   // padding: "20px 34px 12px",
           //   padding: "12px 20px",
           //   boxSizing: "border-box",
           //   boxShadow: "0 2px 10px rgba(0,0,0,0.10)",
           // }}
           // 05-10-2026
            style={{ width: "100%", background: "#ffffff", borderRadius: "10px",
                     // padding: "20px 34px 12px",
                     padding:"12px 20px", boxSizing: "border-box", boxShadow: "0 2px 10px rgba(0,0,0,0.10)", display: "flex",           // new
   flexDirection: "column",   // new
   flex: "1 1 auto",          // new
   minHeight: 0,              // new
   overflow: "hidden",  }}
         >
           {/* //29/10 */}
           <div
   style={{
     overflowX: "auto",
     width: "100%",
     border: "1px solid #d9e1f2",  
     borderRadius: "8px",           
     boxSizing: "border-box",
   }}
 >
          <table
     style={{
       backgroundColor: "white",
       width: "100%",
       minWidth: "70vw",
       borderCollapse: "separate",  // NEW
       borderSpacing: 0,            
     }}
   >
             <thead>
               <tr
                 // style={{
                 //   backgroundColor: "#E5EBFA",
                 //   color: "#222222",
                 //   border: "none",
                 //   height: "34px",
                 //   fontSize: "14px",
                 //   fontWeight: "600",
                 //   textAlign: "center",
                 //   whiteSpace: "nowrap",
                 // }}
                 
                 //28/10
                  style={{
         backgroundColor: "#2D79D9",
         color: "white",
         border: "none",
         height: "34px",
         fontSize: "14px",
         fontWeight: "400",
         textAlign: "center",
         whiteSpace: "nowrap"
     }}
  
               >
                 <th style={thStyle}>Sr.No</th>
                   <th style={thStyle}>Financial Year</th>
                 <th style={thStyle}>Head ID</th>
                 <th style={thStyle}>Head Name</th>
                 {/* <th style={thStyle}>Head Type</th> */}
                 <th style={thStyle}>Head Details</th>
                 <th style={thStyle}>Object Code</th>
                 {/* <th style={thStyle}>Head Sanction Amount</th> */}
                 <th style={thStyle}>CRC</th>
                 {/* <th style={{padding: "10px" }}>Project Name</th>
                                 <th style={thStyle}>Project Cost</th> */}
                 <th style={thStyle}>Creation Date</th>
                 <th  style={thStyle}>Status</th> 
                 <th style={thStyle}>Remark</th>
                  {/* 18-09 */}
 
                 {isMaker && <th style={thStyle}>Action</th>}
                  {isMaker && <th style={thStyle}>Approve</th>}
               </tr>
             </thead>
            <tbody>
   {currentBills && currentBills.length > 0 ? (
     currentBills.map((head, index) => (
       <tr
         key={index}
         style={{
           fontSize: "13px",
           fontWeight: "500",
           whiteSpace: "break-spaces",
            //28/10
           backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
         }}
       >
         {/* //3/11 */}
         <td style={{ padding: "10px", border:"1px solid white" }}>
           {indexOfFirstBill + index + 1}
         </td>
          {/* //3/11 */}
         <td style={{ padding: "10px", border:"1px solid white" }}>{head.FinancialYear}</td>
         {/* //29/10 */}
           {/* //3/11 */}
           <td style={{ padding: "10px" ,color:"blue", border:"1px solid white"}}>{head.HeadID}</td>
         <td style={{ padding: "10px", border:"1px solid white" }}>{head.HeadName}</td>
         <td style={{ padding: "10px",  border:"1px solid white" }}>{head.HeadDetails}</td>
         <td style={{ padding: "10px", border:"1px solid white" }}>{head.objectCode}</td>
         <td style={{ padding: "10px", border:"1px solid white" }}>{head.CRC}</td>
         <td style={{ padding: "10px", border:"1px solid white" }}>
           {head.Date?.split("T")[0].replace(" ")}
         </td>
         {/* <td style={{ padding: "10px" }}>{head.Status}</td> */}
         {/* 08-10 statys color */}
           {/* //3/11 */}
           <td style={{ padding: "10px", textAlign: "center", border:"1px solid white" }}>
   <StatusBadge status={head. Status} />
 </td>
            {/* //3/11 */}
          <td style={{ padding: "10px",  border:"1px solid white" }}> {head.Remark || "-"}  </td>
  {/* 18-09 */}
 
 {isMaker && (
   
   <td style={{ padding: "10px", textAlign: "center",  border:"1px solid white" }}>
     <button
       onClick={() => {
         setEditData(head);
         setOpenEdit(true);
       }}
       disabled={head.Status !== "SendBack"}
       style={{
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         gap: "5px",
         margin: "auto",
         padding: "6px 12px",
         background:
           head.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
         color: "#fff",
         border: "none",
         borderRadius: "6px",
         fontSize: "13px",
         fontWeight: "600",
         cursor: head.Status === "SendBack" ? "pointer" : "not-allowed",
       }}
     >
       <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
       Edit
     </button>
   </td>
 )}
 
 {isMaker && (
   <td style={{ padding: "10px", textAlign: "center",  border:"1px solid white" }}>
     <button
       onClick={() => handleApprove(head)}
       disabled={head.Status !== "SendBack"}
       style={{
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         gap: "5px",
         margin: "auto",
         padding: "6px 12px",
         background:
           head.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
         color: "#fff",
         border: "none",
         borderRadius: "6px",
         fontSize: "13px",
         fontWeight: "600",
         cursor: head.Status === "SendBack" ? "pointer" : "not-allowed",
       }}
     >
       <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
       Approve
     </button>
   </td>
 )}
       </tr>
     ))
   ) : (
     <tr>
       <td
         colSpan="12"
         style={{
           padding: "30px",
           textAlign: "center",
           color: "#777",
           fontSize: "14px",
           fontWeight: "600",
         }}
       >
         No Head Found
       </td>
     </tr>
   )}
 </tbody>
           </table>
 </div>
           <div
             style={{
               width: "100%",
               display: "flex",
               alignItems: "center",
               justifyContent: "space-between",
               marginTop: "15px",
               padding: "10px 5px",
               boxSizing: "border-box",
               flexShrink:0
             }}
           >
             {/* Showing Entries */}
             <div
               style={{
                 fontSize: "13px",
                 color: "#333",
                 whiteSpace: "nowrap",
               }}
             >
               Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1}{" "}
               to {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
               {filteredBills?.length || 0} entries
             </div>
 
             {/* Pagination */}
             <div
               style={{
                 display: "flex",
                 alignItems: "center",
                 gap: "18px",
               }}
             >
               {/* Previous */}
               <button
                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                 disabled={currentPage === 1}
                 style={{
                   border: "none",
                   background: "transparent",
                   color: currentPage === 1 ? "#999" : "#2ea4e7",
                   cursor: currentPage === 1 ? "not-allowed" : "pointer",
                   fontSize: "13px",
                   padding: 0,
                   display: "flex",
                   alignItems: "center",
                   gap: "4px",
                   opacity: currentPage === 1 ? 0.5 : 1,
                 }}
               >
                 <span style={{ fontSize: "20px" }}>‹</span>
                 Previous
               </button>
 
               {/* Page Numbers */}
               <div
                 style={{
                   display: "flex",
                   alignItems: "center",
                   gap: "20px",
                 }}
               >
                 {getPageNumbers(currentPage, totalPages).map(
                   (pageNumber, index) => (
                     <button
                       key={pageNumber}
                       onClick={() => setCurrentPage(pageNumber)}
                       style={{
                         border: "none",
                         background: "transparent",
                         padding: 0,
                         color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                         cursor: "pointer",
                         fontSize: "13px",
                         fontWeight: currentPage === pageNumber ? "600" : "400",
                         textDecoration:
                           currentPage === pageNumber ? "underline" : "none",
                       }}
                     >
                       {pageNumber}
                     </button>
                   ),
                 )}
               </div>
 
               {/* Next */}
               <button
                 onClick={() =>
                   setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                 }
                 disabled={currentPage === totalPages || totalPages === 0}
                 style={{
                   border: "none",
                   background: "transparent",
                   color:
                     currentPage === totalPages || totalPages === 0
                       ? "#999"
                       : "#2ea4e7",
                   cursor:
                     currentPage === totalPages || totalPages === 0
                       ? "not-allowed"
                       : "pointer",
                   fontSize: "13px",
                   padding: 0,
                   display: "flex",
                   alignItems: "center",
                   gap: "4px",
                   opacity:
                     currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
                 }}
               >
                 Next
                 <span style={{ fontSize: "20px" }}>›</span>
               </button>
             </div>
           </div>
         </div>
 
         {/* previous pagination */}
         {/* <div
           style={{
             display: "flex",
             justifyContent: "space-between",
             alignItems: "center",
             marginTop: "20px",
           }}
         >
           <div>
             <p style={{ fontSize: "18px", color: "black" }}>
               Showing{" "}
               {filteredBills?.length
                 ? Math.min(indexOfFirstBill + 1, filteredBills?.length)
                 : 0}{" "}
               to {Math.min(indexOfLastBill, filteredBills?.length)} of{" "}
               {filteredBills?.length} entries
             </p>
           </div>
 
           <div style={{ display: "flex" }}>
             <button
               onClick={() => setCurrentPage(1)}
               disabled={currentPage === 1}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &laquo;
             </button>
 
             <button
               onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
               disabled={currentPage === 1}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &lt;
             </button>
 
             <button
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 background:
                   "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )",
                 color: "white",
                 border: "1px solid #cccccc",
               }}
             >
               {currentPage}
             </button>
 
             <button
               onClick={() =>
                 setCurrentPage((prev) => Math.min(totalPages || 1, prev + 1))
               }
               disabled={currentPage === totalPages}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor:
                   currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &gt;
             </button>
 
             <button
               onClick={() => setCurrentPage(totalPages)}
               disabled={currentPage === totalPages}
               style={{
                 padding: "8px 10px",
                 fontSize: "18px",
                 fontWeight: "bold",
                 width: "2rem",
                 height: "2.5rem",
                 display: "flex",
                 alignItems: "center",
                 justifyContent: "center",
                 backgroundColor:
                   currentPage === totalPages ? "#ffffff" : "#e5f4fb",
                 color: "#044c92",
                 border: "1px solid #cccccc",
                 cursor: "pointer",
                 transition: "0.2s ease-in-out",
               }}
             >
               &raquo;
             </button>
           </div>
         </div> */}
       </div>
       
     )}
     </div> {/* 18-09 */}
         {openEdit && (
       <div style={{ width: "100%" }}>
         <div style={{ display: "flex", justifyContent: "flex-end", }}>
           <button
             onClick={() => {
               setOpenEdit(false);
               setEditData(null);
             }}
             style={{
               background: "#0d6efd",
               color: "#fff",
               border: "none",
               padding: "10px 18px",
               borderRadius: "8px",
               fontWeight: "600",
               cursor: "pointer",
             }}
           >
             ← Back
           </button>
         </div>
 
         <BudgetHeadCreation
           isEdit={true}
           projectDatainward={editData}
           onSuccess={() => {
             setOpenEdit(false);
             setEditData(null);
             getBudgetHeadList(); // refresh the list after saving
           }}
           onCancel={() => {
             setOpenEdit(false);
             setEditData(null);
           }}
         />
       </div>
     )}
     </div>
   );
};

export default BudgetHeadList;
